export const FORM_FORMAT = {
  TABLE_DATE: 'DD/MM/YY',
  TABLE_DATEFULLYEAR: 'DD/MM/YYYY',
  TABLE_DATETIME: 'DD/MM/YY HH:mm:ss'
};
